import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { api } from "@/lib/api";

let cached = null; // módulo-level: una sola petición por sesión de página

/* Platform Economics — fuente única de verdad (Admin → Economics).
   Devuelve los importes vigentes YA formateados para el locale activo:
   { fee: "50 €", commission: "1,5%", loading } — nunca cifras hardcodeadas. */
export function usePlatformPricing() {
  const { i18n } = useTranslation();
  const [data, setData] = useState(cached);

  useEffect(() => {
    if (cached) return;
    api.get("/public/platform-pricing")
      .then(({ data: d }) => {
        cached = d;
        setData(d);
      })
      .catch(() => {});
  }, []);

  const locale = i18n.resolvedLanguage;
  if (!data) return { fee: null, commission: null, loading: true };

  const fee = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: data.currency || "EUR",
    maximumFractionDigits: data.publication_fee_cents % 100 === 0 ? 0 : 2,
  }).format(data.publication_fee_cents / 100);
  const commission = `${(data.commission_bps / 100).toLocaleString(locale)}%`;
  return { fee, commission, loading: false, raw: data };
}
